import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcMediaLink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m11.749 10.199.257.014-.146 1.995c-1.644-.121-3.1.64-4.073 2.18l-.13.215-2.286 3.96c-1.432 2.48-.675 5.053 1.973 6.582a6.15 6.15 0 0 0 1.975.748c1.851.334 3.512-.42 4.587-2.122l.126-.209 2.285-3.959c1.094-1.894.917-3.846-.43-5.353l-.154-.165 1.433-1.395c2.054 2.112 2.44 5.004 1.018 7.671l-.135.242-2.285 3.96c-1.484 2.57-4.033 3.797-6.8 3.298a8.141 8.141 0 0 1-2.62-.984c-3.512-2.028-4.653-5.7-2.825-9.098l.12-.217 2.286-3.959c1.302-2.254 3.429-3.487 5.824-3.404Zm12.91-5.075c3.512 2.028 4.654 5.7 2.826 9.098l-.12.217-2.287 3.959c-1.085 1.88-2.75 3.06-4.69 3.342l-.266.033-.202-1.99c1.319-.134 2.47-.873 3.286-2.154l.14-.231 2.286-3.96c1.433-2.48.676-5.053-1.973-6.582-2.577-1.488-5.114-.931-6.569 1.386l-.118.197-2.286 3.959c-.982 1.7-.941 3.446.056 4.88.157.226.338.443.54.65l.211.204-1.354 1.472A7.196 7.196 0 0 1 13.1 18.42c-1.4-2.01-1.503-4.486-.283-6.777l.136-.245 2.286-3.96c1.996-3.456 5.832-4.385 9.419-2.314Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcMediaLink;
